export default {
  eyebrow: 'Portail partenaire',
  title: 'Frais de traitement',
  description:
    'Vous payez les frais de Stripe sur chaque paiement en ligne. Les frais de traitement définis ici sont facturés à vos restaurants pour les couvrir, sauf si un restaurant a son propre taux.',
  card_title: 'Frais de traitement par défaut',
  hint: "Pourcentage en %, plus un montant fixe et un montant minimum facultatifs par paiement. « Tout mode de paiement » s'applique lorsqu'aucun taux propre au mode de paiement n'existe. Une modification s'applique aux paiements effectués après son enregistrement.",
  hint_single:
    "Les frais de traitement s'appliquent à tous les moyens de paiement en ligne qui n'ont pas de taux propre. Une modification s'applique aux paiements effectués après son enregistrement.",
  hidden_rates:
    "Certains modes de paiement ont aussi leur propre taux, défini par le support de votre plateforme. Ceux-ci s'appliquent à la place de ce taux.",
  empty: {
    title: 'Aucun frais de traitement par défaut défini',
    description:
      'Tant que vous n’en avez pas défini, ou confirmé que vous ne facturez aucun frais de traitement à vos restaurants, vos restaurants sur Stripe ne peuvent pas être mis en ligne et ceux déjà en ligne n’acceptent aucun paiement en ligne (les espèces fonctionnent toujours).',
  },
  consent: {
    give: 'Nous payons nous-mêmes les frais de Stripe (confirmer une marge de 0 %)',
    given_title: 'Marge de 0 % confirmée',
    given:
      'Confirmé par {{name}} le {{date}} : les restaurants sans taux propre ne paient aucun frais de traitement, et vous payez les frais de Stripe sur leurs paiements.',
    unknown_manager: 'un ancien gestionnaire',
    withdraw: 'Retirer',
    withdraw_confirm: {
      title: 'Retirer la confirmation de la marge à 0 % ?',
      description:
        'Les restaurants sans taux propre ne pourront alors pas être mis en ligne, et ceux déjà en ligne cesseront d’accepter les paiements en ligne tant que vous n’aurez pas défini un taux ou confirmé à nouveau.',
    },
  },
  buttons: {
    edit: 'Modifier',
    cancel: 'Annuler',
    save: 'Enregistrer',
  },
  toasts: {
    load_error: 'Impossible de charger vos frais de traitement.',
    failed_to_save_changes: 'Impossible d’enregistrer vos frais de traitement.',
    changes_got_saved: 'Frais de traitement enregistrés',
    consent_given: 'Marge de 0 % confirmée',
    consent_withdrawn: 'Confirmation retirée',
  },
};
